









































import { defineComponent, PropType } from "@vue/composition-api";
import { TranslateResult } from "vue-i18n";
import { PaymentPackage } from "@scrile/api-provider/dist/api/PaymentPackageProvider";
import { ContentFeedSearchResult } from "@scrile/api-provider/dist/projects/scrileConnect/ContentFeedProvider";
import BaseSpinner from "@/components/BaseSpinner";
import ContentFeedGrid from "@/components/ContentFeedGrid";
import ContentFeedList from "@/components/ContentFeedList";
import EmptyContent from "@/components/EmptyContent";
import FeedNsfwNotice from "@/components/FeedNsfwNotice";

export default defineComponent({
  name: "ContentFeedView",
  components: { EmptyContent, BaseSpinner, FeedNsfwNotice, ContentFeedGrid, ContentFeedList },
  props: {
    loading: { type: Boolean, default: false },
    showNSFWNotice: { type: Boolean, default: true },
    contentFeedSearchResult: { type: Object as PropType<ContentFeedSearchResult | null> },
    paymentPackages: { type: Array as PropType<PaymentPackage[]>, required: true },
    followedUserIds: { type: Object as PropType<Record<string, boolean>>, default: () => ({}) },
    feedId: { type: String },
    feedListClasses: { type: String },
    enableScroll: { type: Boolean, required: true },
    emptyContentText: { type: String as PropType<TranslateResult | string> },
    enablePinPost: { type: Boolean },
    showFollowButton: { type: Boolean, default: false },
    showReportItem: { type: Boolean, default: true },
    showComment: { type: Boolean, default: true },
    showFooter: { type: Boolean, default: true },
    showShare: { type: Boolean, default: true },
    showPrice: { type: Boolean, default: true },
  },
});
